import { Parser } from '~/api';
import { Backup } from '~/api/models';
import RequestService from './request';

interface CreateBackupRequest {
    name: string;
    ignored?: string;
    locked?: boolean;
}

interface DeployBackupRequest {
    truncate?: boolean;
    reinstall_after_restore?: boolean;
}

export interface DownloadBackupRequest {
    url: string;
}

class BackupsService {
    getAll(req: PaginatableRequest): Promise<ListResponse> {
        return RequestService.get('/servers/:server/backups', req).then(Parser.parse);
    }

    // get resolves the {backup} route binding (by uuidShort) for the explore
    // view. Used by the ModelBindings middleware.
    get(): Promise<Backup> {
        return RequestService.get('/servers/:server/backups/:backup').then(Parser.parse);
    }

    // explore authorizes + audits entry into the explore view. The mount itself
    // is handled over the daemon websocket, not here.
    explore(data: Backup) {
        return RequestService.post(`/servers/:server/backups/${data.uuidShort}/explore`);
    }

    create(data: CreateBackupRequest): Promise<Backup> {
        return RequestService.post('/servers/:server/backups', data).then(Parser.parse);
    }

    toggleLocked(data: Backup): Promise<Backup> {
        return RequestService.post(`/servers/:server/backups/${data.uuidShort}/locked`).then(Parser.parse);
    }

    deploy(data: Backup, options?: DeployBackupRequest) {
        return RequestService.post(`/servers/:server/backups/${data.uuidShort}/deploy`, options ?? {});
    }

    download(data: Backup) {
        return RequestService.get(`/servers/:server/backups/${data.uuidShort}/download`);
    }

    delete(data: Backup) {
        return RequestService.delete(`/servers/:server/backups/${data.id}`);
    }
}

export default new BackupsService();
